import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { financePartnerService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'financeProviderCreditLimit',
  initialState: adapter.getInitialState({
    busy: false,
    updateCreditLimitData: [],
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setUpdateCreditLimitData: (state, { payload }) => ({ ...state, updateCreditLimitData: payload }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchList = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await financePartnerService.fetchCreditLimitList(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchDataForCreditLimitUpdate = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await financePartnerService.fetchDataForCreditLimitUpdate(params);
    dispatch(slice.actions.setUpdateCreditLimitData(resData));
  } catch (err) {
    dispatch(slice.actions.setUpdateCreditLimitData([]));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchList,
  fetchDataForCreditLimitUpdate,
};

const selectors = {
  ...adapter.getSelectors((state) => state.financeProviderCreditLimit),
};

export { actions, selectors };

export default slice.reducer;
